import { mergeProps, Show } from 'solid-js';
import { getTranslationKey } from './utils';
import { getLocalizedString } from '~/i18n/utils';
import { ApplicationTypeEnum } from '~/api';
import { IndividualApplicationContent } from './IndividualApplicationContent';

type ApplicationTypeContentProps = {
  type: ApplicationTypeEnum;
  showDescription?: boolean;
  showTagList?: boolean;
  showIcon?: boolean;
  class?: string;
};

const APPLICATION_TYPE_CONFIG = [
  {
    type: ApplicationTypeEnum.DEFAULT_APPLICATION,
    name: 'web_application',
    description: 'modal_application_type_description_web_application',
    tags: ['tag_confidential_client']
  },
  {
    type: ApplicationTypeEnum.WEB_APPLICATION,
    name: 'web_application',
    description: 'modal_application_type_description_web_application',
    tags: ['tag_confidential_client']
  },
  {
    type: ApplicationTypeEnum.SINGLE_PAGE_APPLICATION,
    name: 'single_page_application',
    description: 'modal_application_type_description_single_page_application',
    tags: ['tag_public_client', 'tag_pkce_enforced']
  },
  {
    type: ApplicationTypeEnum.NATIVE_APPLICATION,
    name: 'native_application',
    description: 'modal_application_type_description_native_application',
    tags: ['tag_public_client', 'tag_pkce_enforced']
  }
] as const;

export default function ApplicationTypeContent(
  props: ApplicationTypeContentProps
) {
  const merged = mergeProps(
    { showDescription: true, showTagList: true, showIcon: true },
    props
  );

  const config = () =>
    APPLICATION_TYPE_CONFIG.find((item) => item.type === merged.type);

  return (
    <div>
      <Show when={config()}>
        {(item) => {
          const c = item();
          return (
            <IndividualApplicationContent
              applicationName={getLocalizedString(getTranslationKey(c.name))}
              description={getLocalizedString(getTranslationKey(c.description))}
              tagsList={[...c.tags]}
              showDescription={merged.showDescription}
              showTagList={merged.showTagList}
              applicationType={merged.type}
              showIcon={merged.showIcon}
              class={merged?.class}
            />
          );
        }}
      </Show>
    </div>
  );
}
